import {useMemo } from "react";
import useMemeberInfo from "./useMemeberInfoHook";
const useSocialLinks = () => {
  const {memberProfile} = useMemeberInfo();
  const { social_media_links = [] } = memberProfile;
  const socialLinks = useMemo(() => {
    if (!Array.isArray(social_media_links)) return [];
    return social_media_links.filter((item) => item?.is_active === true);
  }, [social_media_links]);
  return socialLinks;
};

export default useSocialLinks;
